import { render, staticRenderFns } from "./ProfessionalizingPracticeView.vue?vue&type=template&id=4c5e7a3a&scoped=true"
import script from "./ProfessionalizingPracticeView.vue?vue&type=script&lang=js"
export * from "./ProfessionalizingPracticeView.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalizingPracticeView.vue?vue&type=style&index=0&id=4c5e7a3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5e7a3a",
  null
  
)

export default component.exports